import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mb-4",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "24",
      cy: "24",
      r: "24",
      fill: "#DEF2E7"
    }, null, -1),
    _createElementVNode("g", { transform: "translate(14, 14)" }, [
      _createElementVNode("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: "#23AA71"
      }),
      _createElementVNode("path", {
        d: "M6 10L9 13L14 8",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      })
    ], -1)
  ])))
}
export default { render: render }